import { FileWithPayload, ListRequest } from "commons/types/api/common";

import { AttachmentType } from "components/ui/AttachmentPicker";

export enum LanguageEnum {
    it = "it",
    en = "en",
}

export type MetaFieldsItem = {
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
};

export type MetaFields = {
    [key in LanguageEnum]: MetaFieldsItem;
};

export type Image = {
    id?: string;
    desktop?: FileWithPayload;
    mobile?: FileWithPayload;
};

export type MediaDetail = {
    id: string;
    date: string;
    content_type: string;
    filename: string;
};

export type ImageDetail = {
    id: string;
    desktop_id: string;
    mobile_id: string;
    desktop: MediaDetail;
    mobile: MediaDetail;
};

export type ImagesBody = {
    id?: string;
    graphical_order: number;
    media: Image;
};

export type ImagesDetails = {
    id: string;
    graphical_order: number;
    media_id: string;
    media: ImageDetail;
};

export type DesktopMobileForm = {
    id: string | undefined;
    desktop: AttachmentType;
    mobile: AttachmentType;
};

export type AdvancedListRequest = ListRequest & {
    filterAdvanced?: string;
};

export type FilterType<Operator> = {
    not?: boolean;
    operator: Operator;
};

export type FilterAggregatorType<Operator> = FilterType<Operator> & {
    conditions: Array<FilterType<unknown>>;
};

export type FilterAnd = FilterAggregatorType<"and">;

export type FilterOr = FilterAggregatorType<"or">;

export type FilterFieldValueType<Operator> = FilterType<Operator> & {
    field: string;
    value: Array<string | number | boolean> | string | number | boolean;
};

export type FilterLikeType = FilterFieldValueType<"like">;
export type FilterEqType = FilterFieldValueType<"eq">;
export type FilterGeType = FilterFieldValueType<"ge">;
export type FilterGtType = FilterFieldValueType<"gt">;
export type FilterLeType = FilterFieldValueType<"le">;
export type FilterLtType = FilterFieldValueType<"lt">;
export type FilterInType = FilterFieldValueType<"in">;
